const showAllLinks = document.querySelectorAll(".block-downloads .show-all");

if (showAllLinks) {
	showAllLinks.forEach(showAllLink => {
		showAllLink.addEventListener("click", function(event) {
			event.preventDefault();
			const thisLink = event.target;
			const block = thisLink.closest(".block-downloads");
			
			if (block.classList.contains("is-showing-all")) {
				block.classList.remove("is-showing-all");
				thisLink.textContent = thisLink.getAttribute("data-button-text");
			} else {
				thisLink.setAttribute("data-button-text", thisLink.textContent);
				thisLink.textContent = "Show less";
				block.classList.add("is-showing-all");
			}
		});
	});
}